import { defineComponent, computed, ref } from "vue";
import cloneDeep from "./component-library255.mjs";
import merge from "./component-library256.mjs";
import { getFirstOfferAlternatives, getPriceFormatted, getEnergyEfficiencyProduct } from "@i22/rocket";
import Card from "./component-library71.mjs";
import GoliathImageElement from "./component-library15.mjs";
import EnergyLabel from "./component-library43.mjs";
import OfferTileVariant from "./component-library257.mjs";
import Prices from "./component-library29.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "offer-tile",
  props: {
    offer: { default: void 0 },
    index: { default: void 0 },
    tagTitle: { default: "h2" },
    linkTag: { default: "a" },
    priceOptions: { default: void 0 },
    noTextBrand: { type: Boolean, default: false },
    isHighlight: { type: Boolean },
    highlightContent: { default: void 0 },
    hideVariants: { type: Boolean, default: false },
    hideContract: { type: Boolean },
    hideEnergyLabel: { type: Boolean },
    limitColorVariants: { default: void 0 },
    card: { default: void 0 }
  },
  setup(__props, { expose }) {
    var _a, _b;
    const props = __props;
    const transformedAlternative = computed(
      () => {
        var _a2;
        return (
          // @ts-ignore
          getFirstOfferAlternatives(((_a2 = props == null ? void 0 : props.offer) == null ? void 0 : _a2.productAlternatives) || [])
        );
      }
    );
    const currentVariantArticleNumber = ref(
      ((_b = (_a = props.offer) == null ? void 0 : _a.product) == null ? void 0 : _b.articleNumber) || void 0
    );
    const currentVariant = computed(() => {
      var _a2;
      if (!((_a2 = transformedAlternative.value) == null ? void 0 : _a2.properties) || !currentVariantArticleNumber.value) {
        return props.offer;
      }
      const matchingItem = transformedAlternative.value.properties.flatMap((property) => property.items || []).find((item) => {
        var _a3, _b2;
        return ((_b2 = (_a3 = item == null ? void 0 : item.offer) == null ? void 0 : _a3.product) == null ? void 0 : _b2.articleNumber) === currentVariantArticleNumber.value;
      });
      return (matchingItem == null ? void 0 : matchingItem.offer) || props.offer;
    });
    const isBundle = computed(
      () => {
        var _a2, _b2, _c;
        return ((_b2 = (_a2 = props.offer) == null ? void 0 : _a2.product) == null ? void 0 : _b2.bundle) && "bundledProducts" in props.offer.product && ((_c = props.offer.product.bundledProducts) == null ? void 0 : _c.length);
      }
    );
    const brandName = computed(() => {
      var _a2, _b2, _c, _d, _e;
      if (!((_a2 = props.offer) == null ? void 0 : _a2.product))
        return [];
      const bundledProducts = "bundledProducts" in props.offer.product ? props.offer.product.bundledProducts : void 0;
      if (!bundledProducts)
        return ((_e = (_d = (_c = (_b2 = props.offer) == null ? void 0 : _b2.product) == null ? void 0 : _c.family) == null ? void 0 : _d.brand) == null ? void 0 : _e.name) || [];
      const bundledBrands = bundledProducts.map(({ family }) => {
        var _a3;
        return (_a3 = family == null ? void 0 : family.brand) == null ? void 0 : _a3.name;
      }).filter(Boolean);
      return [...new Set(bundledBrands)];
    });
    const title = computed(() => {
      var _a2, _b2, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
      if ((_a2 = props.offer) == null ? void 0 : _a2.contract)
        return props.offer.contract.name;
      if (((_c = (_b2 = props.offer) == null ? void 0 : _b2.product) == null ? void 0 : _c.family) && "model" in props.offer.product.family) {
        return (_f = (_e = (_d = props.offer) == null ? void 0 : _d.product) == null ? void 0 : _e.family) == null ? void 0 : _f.model;
      }
      if (isBundle.value) {
        return brandName.value.reduce(
          // @ts-ignore
          (brandTitle, currentBrand) => brandTitle == null ? void 0 : brandTitle.replaceAll(currentBrand, ""),
          ((_i = (_h = (_g = props.offer) == null ? void 0 : _g.product) == null ? void 0 : _h.family) == null ? void 0 : _i.name) || ""
        );
      }
      return ((_l = (_k = (_j = props.offer) == null ? void 0 : _j.product) == null ? void 0 : _k.family) == null ? void 0 : _l.name) || "";
    });
    const manualLink = ref(void 0);
    const offerLink = computed(() => {
      var _a2, _b2, _c, _d;
      if (manualLink.value)
        return manualLink.value;
      if ((_b2 = (_a2 = props.offer) == null ? void 0 : _a2.contract) == null ? void 0 : _b2.slug)
        return `/service/${props.offer.contract.slug}`;
      if ((_d = (_c = currentVariant.value) == null ? void 0 : _c.product) == null ? void 0 : _d.slug)
        return `/geraete/${currentVariant.value.product.slug}`;
      return "";
    });
    const extendedCard = computed(() => {
      const cardProps = {
        tag: props.linkTag,
        size: "small",
        href: offerLink.value,
        heading: {
          tag: props.tagTitle,
          text: title.value,
          align: "left",
          itemprop: "name",
          spacesBottomRem: true,
          size: "sm"
        }
      };
      merge(cardProps, cloneDeep(props.card));
      return cardProps;
    });
    const brandNameDisplay = computed(() => {
      if (isBundle.value) {
        if (brandName.value.length > 1)
          return "";
        return brandName.value[0] || "";
      }
      return brandName.value;
    });
    const articleNumber = computed(() => {
      var _a2, _b2;
      return ((_b2 = (_a2 = props.offer) == null ? void 0 : _a2.product) == null ? void 0 : _b2.articleNumber) || "";
    });
    const currentVariantPrices = computed(() => {
      var _a2;
      return ((_a2 = currentVariant.value) == null ? void 0 : _a2.prices) || [];
    });
    const price = computed(
      () => getPriceFormatted(currentVariantPrices.value, "DEFAULT", "ONETIME", props.priceOptions)
    );
    const wasPrice = computed(
      () => getPriceFormatted(currentVariantPrices.value, "WAS", "ONETIME", props.priceOptions)
    );
    const priceMonthly = computed(
      () => getPriceFormatted(currentVariantPrices.value, "DEFAULT", "MONTHLY", props.priceOptions)
    );
    const wasPriceMonthly = computed(
      () => getPriceFormatted(currentVariantPrices.value, "WAS", "MONTHLY", props.priceOptions)
    );
    const colorVariantOffers = computed(() => {
      var _a2, _b2, _c;
      return (_c = (_b2 = (_a2 = transformedAlternative.value) == null ? void 0 : _a2.variants) == null ? void 0 : _b2.COLOR) == null ? void 0 : _c.items;
    });
    const storageVariants = computed(() => {
      var _a2, _b2, _c;
      return (_c = (_b2 = (_a2 = transformedAlternative.value) == null ? void 0 : _a2.variants) == null ? void 0 : _b2.STORAGE) == null ? void 0 : _c.items;
    });
    const sizeVariants = computed(() => {
      var _a2, _b2, _c;
      return (_c = (_b2 = (_a2 = transformedAlternative.value) == null ? void 0 : _a2.variants) == null ? void 0 : _b2.SIZE) == null ? void 0 : _c.items;
    });
    const priceVariants = computed(() => {
      var _a2, _b2, _c;
      return (_c = (_b2 = (_a2 = transformedAlternative.value) == null ? void 0 : _a2.variants) == null ? void 0 : _b2.PRICE) == null ? void 0 : _c.items;
    });
    const hasStock = computed(() => {
      var _a2, _b2, _c;
      return (((_c = (_b2 = (_a2 = props.offer) == null ? void 0 : _a2.product) == null ? void 0 : _b2.availability) == null ? void 0 : _c.stock) || 0) > 0;
    });
    const provider = computed(() => {
      var _a2, _b2, _c;
      return ((_c = (_b2 = (_a2 = props.offer) == null ? void 0 : _a2.product) == null ? void 0 : _b2.availability) == null ? void 0 : _c.provider) || "";
    });
    const articleClass = computed(() => {
      const entries = [];
      if (props.isHighlight) {
        entries.push("offer-tile--highlight");
      }
      return entries;
    });
    const energyLabel = computed(() => {
      var _a2;
      if (props.hideEnergyLabel || !((_a2 = props.offer) == null ? void 0 : _a2.product))
        return void 0;
      return getEnergyEfficiencyProduct(props.offer.product);
    });
    const selectVariant = ({ variant }) => {
      var _a2, _b2;
      if ((_b2 = (_a2 = variant.offer) == null ? void 0 : _a2.product) == null ? void 0 : _b2.articleNumber) {
        currentVariantArticleNumber.value = variant.offer.product.articleNumber;
      }
      manualLink.value = variant.path;
    };
    expose({
      title,
      price,
      wasPrice,
      offerLink,
      hasStock,
      transformedAlternative,
      articleNumber
    });
    return { __sfc: true, props, transformedAlternative, currentVariantArticleNumber, currentVariant, isBundle, brandName, title, manualLink, offerLink, extendedCard, brandNameDisplay, articleNumber, currentVariantPrices, price, wasPrice, priceMonthly, wasPriceMonthly, colorVariantOffers, storageVariants, sizeVariants, priceVariants, hasStock, provider, articleClass, energyLabel, selectVariant, Card, GoliathImageElement, EnergyLabel, OfferTileVariant, Prices };
  }
});
export {
  _sfc_main as default
};
